export const theme = {
  // colors
  mainBackgroundColor: '#f29739',
  primaryColor: '#007BFF',
  secondaryColor: '#6C757D',
  textColor: '#212529',
  borderColor: '#CED4DA',
  menuBgColor: '#c35355',

  // sizes
  labelSize: '1.25rem',
  borderRadius: '4px',
  spacing: '1rem',
  inputPadding: '0.5rem 0.75rem',
  buttonPadding: '0.5rem 1rem',
  buttonFontSize: '1rem',
  containerSize: '400px',

  // font
  fontFamily: "'Roboto', sans-serif",

  // table
  cell: '1rem',
  cellPadding: '0.5rem',
};
